module.exports = __webpack_public_path__ + "static/media/menu-inventory.5d859225.png";